export default __webpack_public_path__ + "static/media/OM.fcbbce41.svg";